import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { EmailCTA } from '@/features/landing/components/EmailCTA';

interface HeroSectionProps {
  cta?: ReactNode;
}

export function HeroSection({ cta }: HeroSectionProps) {
  const { t } = useTranslation();

  return (
    <section className="relative flex flex-col items-center justify-center px-4 py-20">
      <div className="relative z-10 max-w-2xl mx-auto text-center">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img src="/img/logo.png" alt="Safhati" className="w-[420px] max-w-full brightness-0 invert" />
        </div>

        {/* Tagline */}
        <p className="text-white/70 text-sm mb-8 max-w-md mx-auto" style={{ fontFamily: 'var(--font-body)' }}>
          {t('hero.tagline')}
        </p>

        {/* CTA Button / Email Input */}
        <div className="mb-4">
          {cta ?? <EmailCTA location="hero" />}
        </div>

        {/* Divider with "or" */}
        <div className="flex items-center justify-center my-6">
          <div className="border-t border-white/20 flex-1 max-w-[100px]"></div>
          <span className="px-4 text-white/50 text-xs">{t('hero.or')}</span>
          <div className="border-t border-white/20 flex-1 max-w-[100px]"></div>
        </div>

        {/* Learn More Link */}
        <button
          onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })}
          className="text-white/60 text-xs border border-white/20 px-6 py-2 rounded hover:border-primary/50 hover:text-primary transition-colors"
        >
          {t('hero.learnMore')}
        </button>
      </div>
    </section>
  );
}
